// src/store/sessions/types.ts
import { AccountSessionDTO } from '@/api/__generated__/webApi';

export interface AccountSession extends AccountSessionDTO {}

export enum SessionStep {
  Init = 'init',
  List = 'list',
  ConfirmOne = 'confirm-one',
  ConfirmAll = 'confirm-all',
  Pin = 'pin',
  Success = 'success',
}
